import type { DeepPartial, MessageCatalog } from './types';

const ru: DeepPartial<MessageCatalog> = {
  nav: {
    home: 'FalaRus',
    games: 'Игры',
    partner: 'Общение',
    teachers: 'Преподаватели',
    stats: 'Статистика',
    profile: 'Профиль',
  },
  profile: {
    tapPhoto: 'Нажмите, чтобы выбрать фото',
    premiumDaysLeft: 'Premium · осталось {{days}} дн.',
    groups: {
      personal: 'Личное',
      settings: 'Настройки',
      help: 'Помощь',
    },
    rows: {
      profile: 'Профиль',
      certificates: 'Сертификаты',
      invite: 'Пригласить друзей',
      textSize: 'Размер текста',
      notifications: 'Уведомления',
      darkMode: 'Тёмная тема',
      language: 'Язык',
      sound: 'Звук и вибрация',
      help: 'Помощь',
      pricing: 'Тарифы',
      paymentHistory: 'История платежей',
      logout: 'Выйти',
    },
    firstName: 'Имя',
    lastName: 'Фамилия',
    save: 'Сохранить',
    cancel: 'Отмена',
    nameUpdated: 'Имя обновлено',
    avatarUpdated: 'Фото профиля обновлено',
    avatarUploadFailed: 'Не удалось загрузить фото',
    nameRequired: 'Нужно указать имя и фамилию',
    edit: 'Редактировать',
    gender: 'Пол',
    genderMale: 'Мужской',
    genderFemale: 'Женский',
    russianLevel: 'Уровень русского',
    contactSecurity: 'Контакты и безопасность',
    currentPassword: 'Текущий пароль',
    newPassword: 'Новый пароль',
    profileUpdated: 'Профиль обновлён',
  },
  home: {
    premium: 'Premium',
    patentTitle: 'Патент',
    patentSubtitle: 'Подготовка к патенту',
    vnzhTitle: 'ВНЖ',
    vnzhSubtitle: 'Подготовка к ВНЖ',
    questGrammar: 'Грамматика',
    questGrammarSub: 'Изучение правил',
    questVocab: 'Словарь',
    questVocabSub: 'Новые слова',
    questReading: 'Чтение',
    questReadingSub: 'Понимание текста',
    questSpeaking: 'Говорение',
    questSpeakingSub: 'Разговорная практика',
    questSuhbat: 'Вопрос-ответ',
    questSuhbatSub: 'Разговор с преподавателем',
    questStart: 'Начать',
    questRepeat: 'Повторить',
    dayLabel: 'День {{day}}',
    stepLabel: 'Шаг {{current}} / {{total}}',
    minutesLabel: '~{{minutes}} мин',
    prevDay: 'Предыдущий день',
    nextDay: 'Следующий день',
  },
  stats: {
    title: 'Статистика',
    calendarTitle: 'Календарь активности',
    calendarPrevMonth: 'Предыдущий месяц',
    calendarNextMonth: 'Следующий месяц',
    kunlikGrammar: 'Грамматика (ПЗЗ)',
    kunlikVocab: 'Словарь',
    kunlikReading: 'Чтение',
    kunlikSpeaking: 'Говорение',
    kunlikSuhbat: 'Вопрос-ответ',
    kunlikNone: 'Ещё не начато',
    kunlikContinue: 'Продолжить',
    kunlikStart: 'Начать',
  },
  partner: {
    title: 'Общение',
    guestTitle: 'Общение и партнёры',
    guestSubtitle: 'Войдите для чатов, групп и поиска партнёра',
    guestLogin: 'Войти',
    profiles: 'Анкеты',
    profilesSub: 'Выберите партнёра',
    incoming: 'Входящие запросы',
    outgoing: 'Исходящие запросы',
    adminChat: 'Support',
    groupChat: 'Группа вопрос-ответ',
    mentionAlert: 'Вас отметили',
    mentionEmpty: 'Никого не найдено',
    mentionTitle: 'Кого отметить?',
    partnerChat: 'Чат с партнёром',
    noRequests: 'Пока нет запросов',
    noProfiles: 'Пока нет анкет',
    sendRequest: 'Отправить запрос',
    requestSent: 'Запрос отправлен',
    acceptRequest: 'Принять',
    rejectRequest: 'Отклонить',
    cancelRequest: 'Отменить запрос',
    pending: 'Ожидается ответ',
    male: 'Мужской',
    female: 'Женский',
    yearsOld: '{{age}} лет',
    chatSoon: 'Чат скоро появится',
    firstMessage: 'Отправьте первое сообщение!',
    messagePlaceholder: 'Напишите сообщение...',
    endPartnership: 'Завершить общение',
    support: 'Поддержка',
  },
  teachers: {
    videoTitle: 'Видео-презентация',
    title: 'Преподаватели',
    subtitle: 'Учитесь у опытных преподавателей',
    details: 'Подробнее',
    emptyTitle: 'Пока нет преподавателей',
    emptyDesc: 'Когда появятся активные преподаватели, они будут здесь.',
    notFound: 'Преподаватель не найден',
    about: 'Обо мне',
    reviews: 'Отзывы учеников',
    experience: 'Опыт:',
    price: 'Курс в месяц:',
    formatOnline: 'Онлайн',
    formatOffline: 'Офлайн',
    priceNegotiable: 'Цена по договорённости',
    notSpecified: 'Не указано',
    student: 'Ученик',
    trialBook: 'Записаться на пробный урок',
    trialPending: 'Платёж проверяется',
  },
  courses: {
    title: 'Курсы',
    patentTitle: 'Экзамен Patent',
    patentSubtitle: 'Подготовка к экзамену Patent',
    vnzhTitle: 'Экзамен ВНЖ',
    vnzhSubtitle: 'Подготовка к экзамену ВНЖ',
  },
  games: {
    title: 'Игры',
    howToPlay: 'Как играть',
    howToPlayText:
      'Проведите пальцем или мышью по соседним буквам, не отрывая. Если получилось русское слово, ответ внизу заполнится. Каждую клетку можно использовать один раз.',
    reset: 'Сбросить',
    hint: 'Подсказка',
    stageProgress: 'Этап {{stage}} / {{total}}',
    levelLabel: 'Уровень {{level}}',
    nextStage: 'Следующий этап',
    availableStagesEnded: 'Доступные этапы на сегодня закончились',
    stageLocked: 'Этот этап пока закрыт',
    stageEmpty: 'На этом этапе пока нет слов',
    gridGenerationFailed: 'Не удалось построить сетку',
    loginRequired: 'Войдите, чтобы играть',
    loginToPlay: 'Войти, чтобы играть',
    saveProgressFailed: 'Не удалось сохранить прогресс',
  },
  invite: {
    title: 'Пригласить друзей',
    subtitle: 'Приглашайте друзей и получайте бонусы',
    statInvites: 'Приглашения',
    statRegistered: 'Зарегистрировались',
    statPaid: 'Оплатили',
    statBalance: 'Бонусный баланс',
    linkMissing: 'Ссылка недоступна',
    listTitle: 'Список приглашений',
    listEmpty: 'Пока нет приглашений',
    statusPaid: 'Оплатил',
    statusRegistered: 'Зарегистрировался',
    statusInvited: 'Приглашение отправлено',
    bonusNote: 'Бонусный баланс обновляется автоматически',
    shareText: 'Присоединяйтесь к курсу FalaRus',
  },
  help: {
    title: 'Помощь',
    admin: 'Админ',
    online: 'Онлайн',
    offline: 'Офлайн',
    noChats: 'Пока нет переписок',
    noMessages: 'Пока нет сообщений',
    placeholder: 'Опишите проблему или вопрос...',
    image: 'Фото',
    uploadError: 'Не удалось загрузить фото',
    messagesLoading: 'Загрузка сообщений...',
  },
  notFound: {
    title: 'Страница не найдена',
    body: 'Адрес неверный или страница была перемещена.',
    home: 'Главная',
    login: 'Войти',
    footerPatent: 'Курс Patent',
    footerVnzh: 'Курс ВНЖ',
    footerPricing: 'Тарифы',
    footerPrefix: 'Разделы Patent и ВНЖ:',
  },
  payment: {
    historyTitle: 'История платежей',
    statusPending: 'На проверке',
    statusApproved: 'Подтверждено',
    statusRejected: 'Отклонено',
    empty: 'Пока нет платежей',
    popular: 'Популярный',
    buyThreeMonth: '3 МЕС',
    buyYear: '1 ГОД',
    currency: 'сум',
    acceptedBody: 'Ваш платёж принят.',
    acceptedDefault: 'После подтверждения откроются все уроки.',
    acceptedTeacherTrial: 'Ожидайте подтверждения пробного урока.',
    acceptedTitle: 'Платёж принят',
    back: 'Назад',
    backCabinet: 'В кабинет',
    backProfile: 'В профиль',
    backTeacher: 'К преподавателям',
    buyThreeMonthAction: 'Купить 3 месяца',
    buyYearAction: 'Купить 1 год',
    cardCopy: 'Скопировать номер карты',
    cardHolder: 'Держатель карты',
    cardNumber: 'Номер карты',
    chooseAnotherFile: 'Выбрать другой файл',
    contactAdmin: 'Связаться с админом',
    course: 'Курс',
    fileSizeMax: 'Размер файла не более 10 МБ',
    fileTypes: 'Только JPG, PNG, WEBP или PDF',
    nameCopy: 'Скопировать имя',
    needLogin: 'Войдите, чтобы оплатить',
    payExact: 'Переведите точную сумму',
    pendingDefault: 'Платёж проверяется. После подтверждения откроется доступ.',
    pendingTeacherListing: 'Оплата размещения проверяется.',
    pendingTeacherTrial: 'Оплата пробного урока проверяется.',
    pendingTitle: 'Платёж на проверке',
    phoneCopy: 'Скопировать телефон',
    phoneNumber: 'Телефон',
    rahmatStartError: 'Не удалось начать оплату Rahmat',
    selectOrDrop: 'Выберите файл или перетащите сюда',
    service: 'Услуга',
    submit: 'Отправить платёж',
    submitting: 'Отправка...',
    tariff: 'Тариф',
    teacherTrialRubHint: 'Стоимость пробного урока в рублях',
    teacherTrialUzsHint: 'Пробный урок: {{amount}} сум (Rahmat)',
    uploadFormats: 'JPG, PNG, WEBP или PDF, макс. 10 МБ',
    uploadReceipt: 'Загрузите чек или скриншот',
    uploaded: 'загружено',
    amountTitle: 'Сумма оплаты',
    currencyTitle: 'Выберите валюту',
    currencySubtitle: 'В какой валюте хотите оплатить?',
  },
  pricing: {
    pendingNotice: 'Платёж проверяется. Premium активируется после подтверждения.',
    alreadyActive: 'Premium уже активен',
    loadError: 'Не удалось загрузить тарифы',
    whyTitle: 'Почему этот курс?',
    ctaEnroll: 'Записаться на курс',
    vocabTitle: 'Словарь — в 3 шага',
    benefitGrammar: '182-дневный план грамматики',
    benefitVocab: 'Новые слова и упражнения каждый день',
    benefitInteractive: 'Интерактивные задания',
    benefitGames: 'Обучение через игры',
    benefitStats: 'Статистика и серии дней',
    benefitLeaderboard: 'Рейтинг и мотивация',
    whySmartTitle: 'Умный план',
    whySmartDesc: 'Чёткие задачи на каждый день',
    whyGameTitle: 'Игровой формат',
    whyGameDesc: 'Увлекательные упражнения',
    whyStatsTitle: 'Отслеживание прогресса',
    whyStatsDesc: 'Смотрите свои результаты',
    whyLeaderboardTitle: 'Рейтинг',
    whyLeaderboardDesc: 'Соревнуйтесь с другими',
    vocabStepLearnDesc: 'Знакомство со словами на карточках',
    vocabStepTestDesc: 'Проверка знаний тестом',
    vocabStepPairsDesc: 'Найдите пары русский–узбекский',
  },
  rahmat: {
    title: 'Платёж принят',
    body: 'Если доступ ещё не открылся, обновите профиль через несколько секунд.',
    goProfile: 'В профиль',
    goHome: 'Главная',
  },
  kunlik: {
    noQuestions: 'Нет вопросов на этот день',
    selectAnswer: 'Выберите правильный ответ',
    arrangeSentence: 'Составьте предложение',
    clear: 'Очистить',
    learnedWords: 'Изученные слова:',
    stepLearn: 'Знакомство',
    stepTest: 'Тест',
    stepPairs: 'Найти пару',
    completed: 'Завершено',
    daySpeaking: 'День {{day}} · Говорение',
    seqHint2: 'Сначала завершите задание 1',
    seqHint3: 'Сначала завершите задание 2',
    freeLimitTitle: 'Нужна подписка',
    freeLimitBody:
      'Ежедневный курс открывается с полной подпиской. После оплаты доступны все 182 дня.',
    chooseTariff: 'Выбрать тариф',
    continueCta: 'Нажмите, чтобы продолжить',
  },
  common: {
    user: 'Пользователь',
    save: 'Сохранить',
    cancel: 'Отмена',
    back: 'Назад',
    loading: 'Загрузка...',
    loadError: 'Ошибка загрузки',
    retry: 'Повторить',
    today: 'Сегодня',
    close: 'Закрыть',
    copy: 'Копировать',
    copied: 'Скопировано',
    share: 'Поделиться',
    saving: 'Сохранение...',
    finish: 'Завершить',
    start: 'Начать',
    send: 'Отправить',
    unknown: 'Неизвестно',
    pageNotFound: 'Страница не найдена.',
  },
  language: {
    selectTitle: 'Выберите язык',
    selectSubtitle: 'Язык интерфейса приложения',
  },
  install: {
    cardTitle: 'Добавьте приложение на экран «Домой»',
    cardSubtitle: 'Открывайте в одно касание, без браузера',
    action: 'Добавить',
    dismiss: 'Позже',
    profileRow: 'Добавить на экран «Домой»',
    guideTitle: 'Добавить на экран «Домой»',
    guideIosIntro: 'На iPhone это делается через Safari:',
    guideIosStep1: 'Нажмите кнопку «Поделиться» внизу (квадрат со стрелкой вверх).',
    guideIosStep2: 'Прокрутите список и выберите «На экран «Домой»».',
    guideIosStep3: 'Нажмите «Добавить» справа вверху — иконка появится на экране.',
    guideAndroidIntro: 'Через меню браузера:',
    guideAndroidStep1: 'Откройте меню (⋮) справа вверху.',
    guideAndroidStep2: 'Выберите «Установить приложение» или «Добавить на главный экран».',
    guideAndroidStep3: 'Подтвердите — иконка появится на главном экране.',
    guideDesktopIntro: 'На компьютере — из адресной строки:',
    guideDesktopStep1: 'Нажмите значок установки справа в адресной строке.',
    guideDesktopStep2: 'Подтвердите «Установить».',
    installed: 'Приложение установлено!',
    dismissedHint: 'Вы отменили установку. Можно повторить в любой момент.',
    close: 'Закрыть',
  },
  auth: {
    benefits: {
    },
    register: 'Регистрация',
    logIn: 'Войти',
    logInTitle: 'Вход',
    createAccountTitle: 'Регистрация',
    phone: 'Телефон',
    email: 'Email',
    password: 'Пароль',
    createPassword: 'Придумайте пароль',
    rewritePassword: 'Повторите пароль',
    name: 'Имя',
    surname: 'Фамилия',
    emailHint: 'username@gmail.com',
    forgotPassword: 'Забыли пароль?',
    or: 'ИЛИ',
    continueWithGoogle: 'Продолжить с Google',
    noAccount: 'Нет аккаунта? ',
    signUp: 'Зарегистрироваться',
    haveAccount: 'Уже есть аккаунт? ',
    emailRequired: 'Укажите email',
    emailInvalid: 'Некорректный email',
    phoneInvalid: 'Некорректный номер телефона',
    passwordRequired: 'Укажите пароль',
    passwordMinLength: 'Пароль должен быть не короче 6 символов',
    passwordsMismatch: 'Пароли не совпадают',
    nameRequired: 'Укажите имя',
    surnameRequired: 'Укажите фамилию',
    termsPrefix: 'Создавая аккаунт, я принимаю ',
    termsOfUse: 'Условия использования',
    termsAnd: ' и ',
    privacyPolicy: 'Политику конфиденциальности',
    termsSuffix: '.',
    resetTitle: 'Восстановление пароля',
    resetSubtitle: 'Отправим новый пароль на ваш email',
    resetSendPassword: 'Отправить новый пароль',
    resetSuccessTitle: 'Письмо отправлено',
    resetSuccessSubtitle: 'Если аккаунт существует, новый пароль отправлен на email',
    networkError: 'Нет подключения к интернету. Попробуйте снова.',
    genericError: 'Произошла ошибка',
  },
  liveStream: {
    badge: 'В ЭФИРЕ',
    title: 'Прямой эфир',
    join: 'Войти в эфир',
    watchingHint: 'Нажмите микрофон, чтобы говорить, и камеру, чтобы вас видели',
    callTitle: 'Эфир начался',
    callJoin: 'Присоединиться',
    callDecline: 'Позже',
    pushAllow: 'Разрешить',
    pushModalTitle: 'Позвоним, когда начнётся эфир',
    pushModalBody: 'Разрешите уведомления — и вы сразу узнаете о начале прямого эфира, даже если приложение закрыто.',
    pushLater: 'Позже',
    upcomingTitle: 'Ближайшие эфиры',
    noneTitle: 'Сейчас эфира нет',
    noneSubtitle: 'Когда эфир начнётся, уведомление появится на главной и в разделе «Общение»',
    back: 'Назад',
    loadError: 'Не удалось загрузить данные эфира',
  },
};

export default ru;
